export enum TypeAuxiliaire {
    Aucun = "",
    Reservation = "RE",
    ReservationDetail = "RD",
    ReservationDetailSommaire = "DS",
    Facture = "FA",
    Client = "CL",
    Recette = "FO",
    Estime = "ES",
    BonTravail = "BT",
    Contrat = "CO",
    Cache = "CA",
    Enregistrement = "EN",
    TypeUnite = "TU",
    Unite = "UN",
    Produit = "PR",
    Message = "MS"
}